var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Form',{attrs:{"form":_vm.form,"purpose":"add","route":"lab-reports"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }